import { render, staticRenderFns } from "./BadgeStatusProduto.vue?vue&type=template&id=6bae3514&scoped=true"
import script from "./BadgeStatusProduto.vue?vue&type=script&lang=js"
export * from "./BadgeStatusProduto.vue?vue&type=script&lang=js"
import style0 from "./BadgeStatusProduto.vue?vue&type=style&index=0&id=6bae3514&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bae3514",
  null
  
)

export default component.exports